import { render, staticRenderFns } from "./TeachOtoCommunication.vue?vue&type=template&id=453e2d33&scoped=true&"
import script from "./TeachOtoCommunication.vue?vue&type=script&lang=js&"
export * from "./TeachOtoCommunication.vue?vue&type=script&lang=js&"
import style0 from "./TeachOtoCommunication.vue?vue&type=style&index=0&id=453e2d33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e2d33",
  null
  
)

export default component.exports